<template>
    <div class="dropdown cursor-pointer" :id="id" :name="name">
        <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <template v-if="$slots.selected">
                <slot name="selected" :item="options.filter(f => f.value == modelValue)[0]" />
            </template>
            <span v-else>{{ options.filter(f => f.value == modelValue)[0][optionLabel] }}</span>
        </button>
        <ul class="dropdown-menu">
            <template v-for="(item, index) in options" :key="index">
                <li @click="onChange(item[optionValue], $event)">
                    <!-- <template v-if="$slots.option">
                        <slot name="option" :item="item" />
                    </template> -->
                    <a class="dropdown-item" :class="(item.class !== undefined ? item.class : '') + ' ' + (item[optionValue] == modelValue ? 'active' : '')">
                        <template v-if="$slots.option">
                            <slot name="option" :item="item" />
                        </template>
                        <div v-else>{{ item[optionLabel] }}</div>
                    </a>
                </li>
            </template>
        </ul>
    </div>
</template>


<script>
    export default {
        name: 'DropdownC',
        props: {
            modelValue: {
                default: ""
            },
            options: {
                type: Object,
                default: () => {}
            },
            optionValue: {
                type: String,
                default: () => 'value'
            },
            optionLabel: {
                type: String,
                default: () => 'label'
            },
            id: {
                type: String,
                default: () => 'dropdown_id'
            },
            name: {
                type: String,
                default: () => 'dropdown_name'
            },
        },
        setup(_, {emit}) {
            const onChange = (value, event) => {
                emit('update:modelValue', value);
                emit('onChange', value, event);
            };

            return { onChange };
        },
    };
</script>


<style lang="scss" scoped>
.dropdown-menu{
    --bs-dropdown-min-width: auto;
}
.dropdown-item{
    padding: 8px 20px 8px 20px;
}
button.dropdown-toggle {
    display: block;
    padding: 6px 10px;
    text-decoration: none;
    text-align: start;
    width: 100%;
    background: transparent;
    color: #fff;
    border: 1px solid #a0a0a09d;
}
.dropdown-toggle::after{
    background: unset;
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    content: "\f0d7";
    text-align: center;
    vertical-align: middle;
    // transition: var(--bs-accordion-btn-icon-transition);
    float: inline-end;
    border: 0;
}

@media(max-width: 576px){
    button.dropdown-toggle {
        display: inline-flex;
    }
}
</style>